<!-- =========================================================================================
  File Name: SponsorEdit.vue
  Description: Sponsor Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.header-custome{margin-bottom: 15px; padding-left: 2px;}
</style>
<template>
  <div id="page-user-edit">
    <div class="header-custome">
      <h3>Add Photowall</h3>
    </div>
    <vs-alert color="danger" title="Photowall Not Found" :active.sync="photowall_not_found">
      <span>Photowall with id: {{ $route.params.photowallId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="photowall_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Photowall" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <photowall-edit-tab-account class="mt-4" :data="photowall_data" />
            </div>
          </vs-tab>          
          <!-- <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <exhibitor-edit-tab-social class="mt-4" :data="exhibitor_data" />
            </div>
          </vs-tab> -->
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>

<script>
import PhotowallEditTabAccount from "./PhotowallEditTabAccount.vue";
//import ExhibitorEditTabSocial from "./ExhibitorEditTabSocial.vue";

// Store Module
import modulePhotowallManagement from "@/store/photowall-management/modulePhotowallManagement.js";

export default {
  components: {
    PhotowallEditTabAccount,
    //ExhibitorEditTabSocial
  },
  data() {
    return {
      photowall_data: null,
      photowall_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    };
  },
  watch: {
    activeTab() {
      this.fetch_photowall_data();
    }
  },
  methods: {
    fetch_photowall_data() {
      let directory = this.$route.params.directory ? this.$route.params.directory : null
      this.$store
        .dispatch("photowallManagement/fetchPhotowall", directory)
        .then(res => {
          this.photowall_data = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.photowall_not_found = true;
            return;
          }
          console.error(err);
        });
    }
  },
  created() {
    //debugger;
    // Register Module UserManagement Module
    if (!modulePhotowallManagement.isRegistered) {
      this.$store.registerModule("photowallManagement", modulePhotowallManagement);
      modulePhotowallManagement.isRegistered = true;
    }
    this.fetch_photowall_data();
  }
};
</script>